
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import { NGXLogger } from 'ngx-logger';
import { LazyLoadEvent } from 'primeng/components/common/lazyloadevent';
import { Subscription } from 'rxjs/Subscription';
import { ElectricityContractDashboard } from '../../../models/electricity-contract-dashboard.model';
import { Permission } from '../../../models/permission.model';
import { AccountService } from '../../../services/account.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { fadeInOut } from '../../../services/animations';
import { ElectricityContractService } from '../../../services/electricity-contract.service';

@Component({
    selector: 'electricity-dashboard',
    template: require('./electricity-dashboard.component.html'),
    styles: [require('./electricity-dashboard.component.css')],
    animations: [fadeInOut]
})
export class ElectricityDashboardComponent implements OnInit, OnDestroy {
    electricityContracts: ElectricityContractDashboard[] = [];
    selectedContracts: ElectricityContractDashboard[] = [];
    loading: boolean = true;
    startYear: number = moment().year();
    now: Date = new Date();
    totalRecords: number = 0;
    limit = 10;
    contractTypes: string[] = ['Beide', 'Bedrijf', 'Particulier'];
    selectedContractType = 'Beide';
    private subscribers: Subscription[] = [];

    constructor(private accountService: AccountService, private electricityContractService: ElectricityContractService,
        private alertService: AlertService, private ngxLogger: NGXLogger, private router: Router) { }

    ngOnInit(): void {
        // this.loading = true;
        // this.electricityContractService.getAllForDashboard().subscribe((res: ElectricityContract[]) => {
        //     this.electricityContracts = res;
        //     this.loading = false;
        // }, error => {
        //     this.ngxLogger.error(error.message);
        //     throw error;
        // });
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    loadRecords(event: LazyLoadEvent) {
        let orderby = event.sortField;
        if (orderby) {
            if (event.sortOrder > 0) {
                orderby = '-' + orderby;
            }
        } else {
            orderby = '';
        }
        this.loading = true;
        const limit = event.rows;
        const offset = event.first;
        const searchQuery = event.globalFilter instanceof HTMLInputElement ? event.globalFilter.value : event.globalFilter;
        const getAllForDashboardLazyLoadSubscriber = this.electricityContractService.getAllForDashboardLazyLoad(limit, offset, orderby, this.selectedContractType, searchQuery).subscribe(
            (records: { Item1: ElectricityContractDashboard[], Item2: number }) => {
                if (records != null) {
                    this.electricityContracts = records.Item1;
                    this.totalRecords = records.Item2;
                } else {
                    this.electricityContracts = [];
                    this.totalRecords = 0;
                }
                this.loading = false;
            }, error => {
                this.loading = false;
                this.ngxLogger.error(error.message);
                throw error;
            });
        this.subscribers.push(getAllForDashboardLazyLoadSubscriber);
    }

    OnContractTypeChange($event, dt) {
        this.loadRecords(dt);
    }

    exportExcel() {
        if (this.electricityContracts.length > 0) {
            let ids: string = "0";
            if (this.selectedContracts && this.selectedContracts.length > 0) {
                ids = this.selectedContracts.map(z => z.ElectricityContract.Id).toString();
            } else {
                ids = this.electricityContracts.map(z => z.ElectricityContract.Id).toString();
            }

            this.alertService.showMessage('ElektriciteitsContract', 'Bestandsdownload is bezig!', MessageSeverity.info);
            const exportExcelSubscribe = this.electricityContractService.exportExcel(ids).subscribe(data => {
                saveAs(data, 'ElektriciteitsContracten.xlsx');
                this.alertService.showMessage('ElektriciteitsContract', 'Bestandsdownload voltooid!', MessageSeverity.info);
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(exportExcelSubscribe);
        } else {
            this.alertService.showMessage('ElektriciteitsContract', 'Geen enkel contract gevonden!', MessageSeverity.warn);
        }
    }

    edit(cb: ElectricityContractDashboard) {
        switch (cb.ElectricityContract.ECType) {
            case 'A':
                this.router.navigate(['/electricitycontract', cb.ElectricityContract.CType, cb.ElectricityContract.ContractBase.CustomerId, cb.ElectricityContract.ContractBase.Id])
                break;
            case 'I':
                this.router.navigate(['/injectiecontract', cb.ElectricityContract.CType, cb.ElectricityContract.ContractBase.CustomerId, cb.ElectricityContract.ContractBase.Id])
                break;
            default:
                break;
        }
    }

    lookupRowStyleClass(rowData: ElectricityContractDashboard) {
        const now = moment();
        const end = moment(rowData.ContractEndDate);
        const diff = end.diff(now, 'months');
        return diff < 6 ? 'bg-yellow' : '';
    }

    setBackColor(x, endex, value) {
        let color: string;
        if (endex < value) {
            color = '#f56954'; // red
        } else {
            color = '#00a65a'; // green
        }
        x.parentNode.parentNode.style.color = '#ffffff';
        x.parentNode.parentNode.style.backgroundColor = color; // x.parentNode.parentNode accesses the <td> element of table :)
    }

    setTextAndBackColor(x, data: ElectricityContractDashboard, year) {
        const cs = moment(data.ContractStartDate);
        const ce = moment(data.ContractEndDate);
        const ys = moment(new Date(year, 0, 1));
        const ye = moment(new Date(year, 11, 31));
        let text: string;
        let color: string;

        if (cs <= ys && ce >= ye || cs.year() > ys.year()) {
            text = 'G'; // green
            color = '#00a65a'; // green
        } else {
            if (ce >= ye && cs.year() == ys.year()) {
                text = 'G'; // green
                color = '#00a65a'; // green
            } else if (ce.year() == ys.year()) {
                text = "O";
                color = '#f39c12'; // orange
            } else {
                text = 'R'; // red
                color = '#f56954'; // red
            }
        }

        x.parentNode.parentNode.style.color = '#ffffff';
        x.parentNode.parentNode.style.backgroundColor = color; // x.parentNode.parentNode accesses the <td> element of table :)

        return text;
    }

    get canmanageElectricityDashboardPermission() {
        return this.accountService.userHasPermission(Permission.manageElectricityDashboardPermission);
    }

    get canelectricityExport() {
        // const temp: boolean = this.accountService.userHasPermission(Permission.electricityExportPermission);
        return this.accountService.userHasPermission(Permission.electricityExportPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/electricity/electricity-dashboard/electricity-dashboard.component.ts